import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconComponent } from '@backstage/core-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { AppIcons } from '../utils/icons';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';

import { CustomTechDocsIndexPage } from '../components/docs/CustomTechDocsIndexPage';

const appviaTechDocsNavItem = techdocsPlugin
  .getExtension('nav-item:techdocs')
  .override({
    params: {
      icon: AppIcons.docs as IconComponent,
    },
  });

const appviaTechDocsIndexPage = techdocsPlugin
  .getExtension('page:techdocs')
  .override({
    params: {
      loader: async () => compatWrapper(<CustomTechDocsIndexPage />),
    },
  });

export const appviaTechDocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [appviaTechDocsNavItem, appviaTechDocsIndexPage],
});
